/* eslint-disable no-console */
import {
  CrownFilled,
  FileAddOutlined,
  MinusOutlined,
  PlusOutlined,
  SearchOutlined
} from '@ant-design/icons';
import {
  Button,
  // Checkbox,
  Col,
  Divider,
  Flex,
  Form,
  Input,
  Modal,
  Radio,
  Select,
  Table,
  TableColumnsType,
  TableProps,
  Upload
} from 'antd';
// import {CheckboxChangeEvent} from 'antd/es/checkbox';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React, {useCallback, useEffect, useState} from 'react';

import {ReactComponent as FileDownloadIcon} from '../../../../../assets/icons/File_Download.svg';
import PhoneNumberInput from '../../../../../components/CustomInputs/PhoneNumberInput/PhoneNumberInput';
import {
  normalizeEmail,
  normalizeMobile
} from '../../../../../components/DrawerForm/commonFunctions';
import Loader from '../../../../../components/Loader/Loader';
import UpgradeButton from '../../../../../components/UpgradeButton/UpgradeButton';
import {CommonErrors} from '../../../../../constants/Common';
import {SampleExcel} from '../../../../../constants/SampleExcel';
import {responseStatus} from '../../../../../services/constants/responseType';
import userGroupTypeJson from '../../../../../services/modules/JSON/getUserGroup';
import {userManagementUpload} from '../../../../../services/modules/UploadAndJobs/userManagementUpload';
import isUserDuplicate from '../../../../../services/modules/User/isUserDuplicate';
import getEmployees from '../../../../../services/modules/UserManager/getEmployeeDetails';
import getPermissionsApi from '../../../../../services/modules/UserManager/getPermissions';
import getUsersEdit from '../../../../../services/modules/UserManager/getUsersEdit';
import {sortBy} from '../../../../../shared/commonFunctions';
import {
  accessModule,
  countModule
} from '../../../../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../../../../store/StaticJson/jsonStore';
import {debounce} from '../../../../../utils/debounce';
import {FirstCap} from '../../../../../utils/FormUtils/FirstCap';
import RegEx from '../../../../../utils/FormUtils/RegEx';
import showMessage from '../../../../../utils/showMessage';
import {
  hasMaxLimitReached,
  shouldBlockModuleAccess
} from '../../../../../utils/SubscriptionHelper';
import {
  MAX_UPLOAD_LIMIT,
  userDrawerFormKey,
  userDrawerFormLabel
} from '../Constants/commonConst';
import {
  filterPermissionsAndModules,
  roleFilter
} from '../Constants/commonFunctions';
import getLabelsFromSelectedPermissions from '../Constants/getLabelFromPermission';

import ModulePermissionAccordian from './ModulePermissionAccordian';
import {FormType, PostFormData} from './UserManager';

interface ValueDescription {
  value: string;
  description: string;
}

interface NestedObject {
  [key: string]: ValueDescription[] | NestedObject;
}

type PermissionsType = Record<string, NestedObject | ValueDescription[]>;

interface AddUserDrawerProps {
  currentStep?: number;
  onPostDataChange: (data: Partial<PostFormData>) => void;
  postFormData: PostFormData;
}

const AddUserDrawerForm: React.FC<AddUserDrawerProps> = ({
  currentStep,
  postFormData,
  onPostDataChange
}) => {
  // const [selectAll, setSelectAll] = useState<boolean>(false);
  const [allPermissions, setAllPermissions] = useState<PermissionsType>({});
  const [editUsers, setEditUsers] = useState<DataType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingSelectTable, setIsLoadingSelectTable] =
    useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const accessTypes = useJSONStore.getState().accessTypes;
  const {setFieldValue, getFieldValue, validateFields} = useFormInstance();
  const [filterAccessType, setFilterAccessType] = useState(accessTypes ?? []);
  const [userGroupSelected, setUserGroupSelected] = useState('');
  const stackHolderType = useJSONStore.getState().stackHolderTypes;
  const roleTypes = useJSONStore.getState().roleTypes;
  const [shouldCallAPI, setShouldCallAPI] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [visibleMemberFormIds, setVisibleMemberFormIds] = useState<number[]>(
    []
  );
  const [isBulkUploadModalOpen, setIsBulkUploadModalOpen] = useState(false);
  const [shouldOpenBulkUploadPicker, setShouldOpenBulkUploadPicker] =
    useState(false);
  const hasInitializedVisibleFormIds = React.useRef(false);
  const bulkUploadTriggerRef = React.useRef<HTMLSpanElement | null>(null);
  const [checkValidations, setCheckValidationss] = useState<number | null>(
    null
  );
  const userGroupTypes = useJSONStore.getState().userGroupTypes;
  const [pagination, setPagination] = useState<{
    page: number;
    pageSize: number;
    total: number;
  }>({
    page: 1,
    pageSize: 10,
    total: 10
  });
  interface DataType {
    name: string;
    email: string;
    auth0UserId: string | null;
    key: string;
  }
  const allAddMemberForms = postFormData?.addMemberForms ?? [];
  const visibleAddMemberForms = allAddMemberForms.filter((form: FormType) =>
    visibleMemberFormIds.includes(form.id)
  );
  const remainingVisibleSlots = Math.max(
    MAX_UPLOAD_LIMIT - visibleAddMemberForms.length,
    0
  );
  const isVisibleLimitReached = remainingVisibleSlots === 0;
  const shouldShowVisibleLimitInfo =
    allAddMemberForms.length > visibleAddMemberForms.length;

  const handlePermissionsChange = (permissions: string[]) => {
    onPostDataChange({permissions});
  };

  const selectedTableData = editUsers?.filter((item) =>
    postFormData.selectedAdmin ? item.key === postFormData.selectedAdmin : true
  );
  const rowSelection: TableProps<DataType>['rowSelection'] = {
    type: 'radio',
    selectedRowKeys: postFormData?.selectedAdmin
      ? [postFormData.selectedAdmin]
      : [],
    onChange: (selectedRowKeys) => {
      onPostDataChange({selectedAdmin: selectedRowKeys[0] as string});
    }
  };

  const selectedAdminRowSelection: TableProps<DataType>['rowSelection'] = {
    type: 'radio',
    selectedRowKeys: postFormData.selectedAdmin
      ? [postFormData.selectedAdmin]
      : []
  };

  const multiRowSelection: TableProps<DataType>['rowSelection'] = {
    type: 'checkbox',
    selectedRowKeys: postFormData?.users?.map((i) => {
      return i.key;
    }),
    onChange: (selectedRowKeys, record) => {
      onPostDataChange({users: record as any[]});
      // setSelectAll(selectedRowKeys.length === editUsers.length);
    }
  };

  const handleSearch = useCallback(
    debounce(() => {
      setPagination({page: 1, pageSize: 10, total: 10});
      setEditUsers([]);
      setShouldCallAPI(true);
    }),
    []
  );

  // const handleSelectAllChange = (e: CheckboxChangeEvent) => {
  //   if (e.target.checked) {
  //     onPostDataChange({users: editUsers});
  //     setSelectAll(true);
  //   } else {
  //     onPostDataChange({users: []});
  //     setSelectAll(false);
  //   }
  // };
  const handleSearchTermChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {value} = e.target;
    setSearchTerm(value.trim());
    handleSearch();
  };

  const handleInputChange = (id: number, field: string, value: string) => {
    const updatedForms = postFormData?.addMemberForms?.map((form: FormType) =>
      form.id === id ? {...form, [field]: value} : form
    );
    onPostDataChange({addMemberForms: updatedForms});
  };

  useEffect(() => {
    if (shouldOpenBulkUploadPicker && bulkUploadTriggerRef.current) {
      bulkUploadTriggerRef.current.click();
      setShouldOpenBulkUploadPicker(false);
    }
  }, [shouldOpenBulkUploadPicker]);

  useEffect(() => {
    const availableFormIds = new Set(allAddMemberForms.map((form) => form.id));
    setVisibleMemberFormIds((prevVisibleIds) => {
      const validVisibleIds = prevVisibleIds.filter((id) =>
        availableFormIds.has(id)
      );
      if (allAddMemberForms.length === 0) {
        hasInitializedVisibleFormIds.current = false;

        return validVisibleIds;
      }
      if (validVisibleIds.length > 0) {
        return validVisibleIds;
      }
      if (hasInitializedVisibleFormIds.current) {
        return validVisibleIds;
      }
      hasInitializedVisibleFormIds.current = true;

      return allAddMemberForms
        .slice(0, MAX_UPLOAD_LIMIT)
        .map((form) => form.id);
    });
  }, [allAddMemberForms]);

  const findDuplicates = (
    value: string,
    field: 'emailAddress' | 'phoneNumber'
  ) => {
    if (!value) return false;

    const formsValues =
      getFieldValue(userDrawerFormKey.ADD_MEMBER_FORMS) ??
      postFormData?.addMemberForms ??
      [];
    const duplicateCount = formsValues?.filter((form: FormType) => {
      const fieldValue = (form?.[field] ?? '').toString();
      const normalizedFieldValue =
        field === userDrawerFormKey.EMAIL
          ? normalizeEmail(fieldValue)
          : normalizeMobile(fieldValue);

      return normalizedFieldValue === value;
    }).length;

    return duplicateCount > 1;
  };

  const handleAddForm = () => {
    if (isVisibleLimitReached) {
      return;
    }
    const newForm = {
      id: Date.now(),
      firstName: '',
      lastName: '',
      emailAddress: '',
      phoneNumber: ''
    };
    setVisibleMemberFormIds((prevVisibleIds) => {
      if (prevVisibleIds.length >= MAX_UPLOAD_LIMIT) return prevVisibleIds;

      return [...prevVisibleIds, newForm.id];
    });
    if (allAddMemberForms.length > 0) {
      onPostDataChange({
        addMemberForms: [...allAddMemberForms, newForm]
      });
    } else {
      onPostDataChange({addMemberForms: [newForm]});
    }
  };

  const handleRemoveForm = (formId: number) => {
    const filteredForm = postFormData?.addMemberForms?.filter(
      (el: FormType) => el.id !== formId
    );
    setVisibleMemberFormIds((prevVisibleIds) =>
      prevVisibleIds.filter((id) => id !== formId)
    );
    onPostDataChange({addMemberForms: filteredForm});
    setFieldValue(userDrawerFormKey.ADD_MEMBER_FORMS, filteredForm);
  };

  useEffect(() => {
    if (checkValidations === null) return;

    const memberForms = postFormData?.addMemberForms ?? [];
    if (memberForms.length < checkValidations) return;

    validateFields(
      memberForms?.flatMap((_: FormType, index: number) => [
        [userDrawerFormKey.ADD_MEMBER_FORMS, index, userDrawerFormKey.EMAIL],
        [userDrawerFormKey.ADD_MEMBER_FORMS, index, userDrawerFormKey.MOBILE]
      ])
    )
      .catch(() => {})
      .finally(() => {
        setCheckValidationss(null);
      });
  }, [postFormData?.addMemberForms, checkValidations]);

  // const filteredData = editUsers.filter(
  //   (user) =>
  //     user.email.toLowerCase().includes(searchTerm?.toLowerCase()) ||
  //     user.name.toLowerCase().includes(searchTerm?.toLowerCase())
  // );

  const columns: TableColumnsType<DataType> = [
    {
      title: userDrawerFormLabel.NAME,
      dataIndex: userDrawerFormKey.NAME
    },
    {
      title: userDrawerFormLabel.EMAIL,
      dataIndex: 'email'
    }
  ];

  useEffect(() => {
    if (postFormData.roles) {
      const accessType = roleTypes.find((i) => {
        return i.name === postFormData.roles;
      }).accessType;
      setFilterAccessType(
        accessTypes.filter((i) => {
          return accessType?.includes(i?.name);
        })
      );
    }
  }, []);

  useEffect(() => {
    setIsLoading(true);
    Promise.all([
      postFormData.selectedStackHolder
        ? getPermissionsApi(postFormData.selectedStackHolder ?? 'Internal')
        : Promise.resolve([]),
      postFormData.selectedStackHolder === 'Internal'
        ? getEmployees({...pagination, searchParam: searchTerm})
        : postFormData.selectedStackHolder === 'External' &&
            postFormData.selectedUserGroup
          ? getUsersEdit(postFormData.selectedUserGroup, {
              ...pagination,
              searchParam: searchTerm
            })
          : Promise.resolve({users: [], total: 100}),
      postFormData.selectedStackHolder === 'External'
        ? userGroupTypeJson()
        : Promise.resolve([])
    ])
      .then(([permissions, employeesOrUsers]) => {
        setAllPermissions(permissions);
        setEditUsers((prev) => {
          return [...prev, ...(employeesOrUsers?.users ?? [])];
        });
        setPagination((prev) => {
          return {...prev, total: employeesOrUsers?.total};
        });
      })
      .catch(() => {
        setAllPermissions({});
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [postFormData.selectedStackHolder]);

  useEffect(() => {
    if (
      postFormData.selectedStackHolder === 'External' &&
      postFormData.selectedUserGroup &&
      shouldCallAPI
    ) {
      setIsLoadingSelectTable(true);
      showMessage({status: 'info', message: 'Fetching users...'});
      Promise.all([
        getUsersEdit(postFormData.selectedUserGroup, {
          ...pagination,
          searchParam: searchTerm
        })
      ])
        .then(([userData]) => {
          setEditUsers((prev) => {
            return [...prev, ...(userData?.users ?? [])];
          });
          setPagination((prev) => {
            return {...prev, total: userData?.total};
          });
        })
        .catch(() => {})
        .finally(() => {
          setShouldCallAPI(false);
          showMessage({status: 'success', message: 'Users fetched'});
          setIsLoadingSelectTable(false);
        });
    }
  }, [postFormData.selectedUserGroup, shouldCallAPI]);

  useEffect(() => {
    if (postFormData.selectedStackHolder === 'Internal' && shouldCallAPI) {
      setIsLoadingSelectTable(true);
      showMessage({status: 'info', message: 'Fetching users...'});
      Promise.all([getEmployees({...pagination, searchParam: searchTerm})])
        .then(([userData]) => {
          setEditUsers((prev) => {
            return [...prev, ...(userData?.users ?? [])];
          });
          setPagination((prev) => {
            return {...prev, total: userData?.total};
          });
        })
        .catch(() => {})
        .finally(() => {
          setShouldCallAPI(false);
          showMessage({status: 'success', message: 'Users fetched'});
          setIsLoadingSelectTable(false);
        });
    }
  }, [shouldCallAPI]);

  const shouldBlockStackHolder = (userType: string) => {
    if (
      userType === 'Internal' &&
      (hasMaxLimitReached(countModule.internalUsers) ||
        shouldBlockModuleAccess(accessModule.internalUsers))
    ) {
      return true;
    } else if (
      userType === 'External' &&
      (hasMaxLimitReached(countModule.externalStakeholders) ||
        shouldBlockModuleAccess(accessModule.externalStakeholders))
    ) {
      return true;
    }

    return false;
  };

  if (currentStep === 0)
    return (
      <>
        <Col className="gutter-row">
          <Form.Item
            name="StackholderType"
            label="Stakeholder Type"
            labelCol={{span: 24}}
            rules={[
              {
                required: true,
                message: CommonErrors.mandatory('Stakeholder Type')
              }
            ]}
          >
            <Select
              showSearch
              className="select"
              options={sortBy(stackHolderType, 'label', 'asc').map((option) => {
                return {
                  ...option,
                  label: (
                    <Flex align="center" justify="space-between">
                      <div>{option.label}</div>
                      {shouldBlockStackHolder(option.label) && (
                        <CrownFilled
                          style={{color: '#FFD700', paddingRight: 10}}
                          title="Upgrade Plan"
                        />
                      )}
                    </Flex>
                  ),
                  disabled: shouldBlockStackHolder(option.label)
                };
              })}
              placeholder="Choose Stakeholder Type"
              value={postFormData.selectedStackHolder}
              onChange={(value) => {
                onPostDataChange({
                  selectedStackHolder: value,
                  selectedUserGroup: '',
                  roles: undefined,
                  selectedAccess: null,
                  permissions: []
                });
                setFieldValue('Access', null);
                setFieldValue('userGroup', undefined);
                setFieldValue('Role', undefined);
                setEditUsers([]);
                setPagination({page: 1, pageSize: 10, total: 10});
                setSearchTerm('');
                setFieldValue('Admin Search', '');
              }}
            />
          </Form.Item>
        </Col>

        {postFormData.selectedStackHolder === 'External' && (
          <Col className="gutter-row">
            <Form.Item
              name="userGroup"
              label="User Group"
              labelCol={{span: 24}}
              rules={[
                {required: true, message: CommonErrors.mandatory('User group')}
              ]}
            >
              <Select
                allowClear
                showSearch
                className="select"
                placeholder="Choose User Group"
                value={postFormData.selectedUserGroup ?? ''}
                options={sortBy(
                  userGroupTypes.map((group) => ({
                    value: group._id,
                    label: group.name
                  })),
                  'label',
                  'asc'
                )}
                disabled={isLoading || isLoadingSelectTable}
                loading={isLoading || isLoadingSelectTable}
                onChange={(value, record: any) => {
                  const groupLabel = record?.label ?? '';
                  const matchedRole = roleTypes.find((role) => {
                    return (
                      role.type === 'External' &&
                      role.name.startsWith(groupLabel?.slice(0, -1)) &&
                      !role.name.includes('Admin')
                    );
                  });
                  onPostDataChange({
                    selectedUserGroup: value,
                    roles: matchedRole?.name,
                    selectedAccess: null,
                    permissions: [],
                    selectedAdmin: undefined
                  });
                  setShouldCallAPI(true);
                  setUserGroupSelected(groupLabel);
                  setFieldValue('Access', null);
                  setFieldValue('Role', matchedRole?.name);
                  setFilterAccessType(
                    accessTypes.filter((i) => {
                      return matchedRole?.accessType?.includes(i?.name);
                    })
                  );
                  setEditUsers([]);
                  setPagination({page: 1, pageSize: 10, total: 10});
                  setSearchTerm('');
                  setFieldValue('Admin Search', '');
                }}
                filterOption={(input, option) =>
                  option?.label.toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>
          </Col>
        )}

        {postFormData.selectedStackHolder && (
          <Col className="gutter-row">
            <Form.Item
              name="Role"
              label="Role"
              labelCol={{span: 24}}
              rules={[
                {required: true, message: CommonErrors.mandatory('Role Type')}
              ]}
            >
              <Select
                allowClear
                showSearch
                className="select"
                placeholder="Choose Role"
                value={postFormData.roles ?? ''}
                disabled={postFormData.selectedStackHolder === 'External'}
                options={sortBy(
                  roleTypes
                    .filter((role) => {
                      return postFormData.selectedStackHolder === 'External'
                        ? role.type === postFormData.selectedStackHolder &&
                            role.name.startsWith(
                              userGroupSelected?.slice(0, -1)
                            ) &&
                            !role.name.includes('Admin')
                        : role.type === postFormData.selectedStackHolder &&
                            roleFilter().includes(role.name);
                    })
                    .map((role) => ({
                      label: role.name,
                      value: role.name,
                      accessType: role.accessType
                    })),
                  'label',
                  'asc'
                )}
                onChange={(value, record: any) => {
                  onPostDataChange({
                    roles: value,
                    selectedAccess: null,
                    permissions: []
                  });
                  setFieldValue('Access', null);
                  setFilterAccessType(
                    accessTypes.filter((i) => {
                      return record?.accessType?.includes(i?.name);
                    })
                  );
                }}
                filterOption={(input, option) =>
                  option?.label.toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>
          </Col>
        )}
        {postFormData.roles && (
          <Col className="gutter-row">
            <Form.Item
              name="Access"
              label="Access"
              labelCol={{span: 24}}
              rules={[
                {required: true, message: CommonErrors.mandatory('Access Type')}
              ]}
              initialValue={null}
            >
              <Radio.Group
                value={postFormData.selectedAccess ?? null}
                onChange={(e) => {
                  onPostDataChange({selectedAccess: e.target.value});
                }}
                style={{display: 'flex', justifyContent: 'start'}}
              >
                {filterAccessType.map((accessType) => {
                  return (
                    <Radio
                      key={accessType.description}
                      value={accessType.description}
                    >
                      {accessType.description}
                    </Radio>
                  );
                })}
              </Radio.Group>
            </Form.Item>
          </Col>
        )}
        {postFormData.roles && (
          <>
            {isLoading ? (
              <Loader />
            ) : (
              <Col className="gutter-row">
                <Form.Item
                  name="permissions"
                  label={
                    <span
                      style={{
                        fontSize: '16px',
                        fontWeight: 600,
                        marginTop: '10px'
                      }}
                    >
                      Choose Modules & Permissions
                    </span>
                  }
                  labelCol={{span: 24}}
                  className="permissionsUM"
                  rules={[
                    {
                      required: true,
                      validator: async () => {
                        if (
                          postFormData.permissions &&
                          postFormData.permissions.length > 0
                        ) {
                          await Promise.resolve();

                          return;
                        }

                        return await Promise.reject(
                          new Error('Please select at least one permission.')
                        );
                      }
                    }
                  ]}
                />
                <ModulePermissionAccordian
                  allPermissions={filterPermissionsAndModules(
                    allPermissions,
                    postFormData?.roles ?? ''
                  )}
                  postFormData={postFormData}
                  onPostDataChange={(data: Partial<PostFormData>) => {
                    handlePermissionsChange(data.permissions ?? []);
                  }}
                />
              </Col>
            )}
          </>
        )}
      </>
    );
  if (currentStep === 1)
    return (
      <>
        <Col className="gutter-row">
          <Form.Item name="Admin Search" labelCol={{span: 24}}>
            <Input
              style={{height: '40px'}}
              placeholder="Search by Name or Email ID"
              suffix={
                <SearchOutlined style={{fontSize: '20px', color: '#9496A1'}} />
              }
              value={searchTerm}
              onChange={handleSearchTermChange}
            />
          </Form.Item>
        </Col>

        {postFormData.selectedStackHolder === 'External' && (
          <Col>
            <Form.Item
              name="Admin Select"
              labelCol={{span: 24}}
              label="Select Admin"
              rules={[
                {
                  required: true,
                  validator: async () => {
                    if (editUsers.length > 0 && postFormData?.selectedAdmin) {
                      await Promise.resolve();

                      return;
                    }

                    return await Promise.reject(
                      new Error('Please select at least one admin.')
                    );
                  }
                }
              ]}
            >
              {postFormData.selectedAdmin ? (
                <>
                  {isLoading ? (
                    <Loader />
                  ) : (
                    <div
                      className="e1"
                      style={{
                        border: '1px solid #D2D4DA',
                        borderRadius: '12px',
                        overflow: 'hidden'
                      }}
                    >
                      <Table
                        rowKey="key"
                        dataSource={selectedTableData}
                        columns={columns}
                        pagination={false}
                        className="custom-table"
                        showHeader={false}
                        rowSelection={selectedAdminRowSelection}
                        loading={isLoading}
                      />
                    </div>
                  )}
                </>
              ) : (
                <>
                  {isLoading ? (
                    <Loader />
                  ) : (
                    <div
                      className="e2"
                      style={{
                        border: '1px solid #D2D4DA',
                        borderRadius: '12px',
                        overflow: 'hidden'
                      }}
                    >
                      <Table
                        rowKey="key"
                        rowSelection={rowSelection}
                        dataSource={editUsers}
                        columns={columns}
                        pagination={false}
                        showHeader={false}
                        scroll={{y: 500}}
                        {...({
                          onScroll: (e: any) => {
                            const maxScroll =
                              e.target.scrollHeight - e.target.clientHeight;
                            const currentScroll = e.target.scrollTop;
                            const {page, pageSize, total} = pagination;
                            if (currentScroll === maxScroll) {
                              if (page * pageSize < total) {
                                setShouldCallAPI(true);
                                setPagination((prev) => {
                                  const {page} = prev;

                                  return {...prev, page: page + 1};
                                });
                              } else {
                                showMessage({
                                  status: 'info',
                                  message: 'End Of List'
                                });
                              }
                            }
                          }
                        } as any)}
                        loading={isLoadingSelectTable}
                      />
                    </div>
                  )}
                </>
              )}
            </Form.Item>
          </Col>
        )}
        {postFormData.selectedAdmin &&
          postFormData.selectedStackHolder === 'External' &&
          selectedTableData.length > 0 && (
            <>
              <Col className="gutter-row">
                <div
                  style={{
                    display: 'flex',
                    gap: '10px',
                    alignItems: 'center',
                    width: '100px'
                  }}
                >
                  <Button
                    className="add-member-btn"
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={handleAddForm}
                    disabled={
                      (Array.isArray(postFormData?.addMemberForms) &&
                        postFormData.addMemberForms.length > 0) ||
                      isVisibleLimitReached
                    }
                  >
                    Add Member
                  </Button>
                  <Divider style={{minWidth: '99%'}}>Or</Divider>
                  <Upload
                    accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    beforeUpload={(file) => {
                      if (!file.name.toLowerCase().endsWith('.xlsx')) {
                        showMessage({
                          status: 'error',
                          message:
                            'Invalid file type. Please upload an XLSX file.'
                        });

                        return Upload.LIST_IGNORE;
                      }

                      return true;
                    }}
                    customRequest={(option) => {
                      setIsUploading(true);
                      userManagementUpload(option.file)
                        .then((res) => {
                          if (res?.status === responseStatus.ERROR) {
                            showMessage(res, 10);

                            return;
                          }
                          const uploadedForms = (res ?? []) as FormType[];
                          showMessage({
                            status: 'success',
                            message: 'Users uploaded successfully'
                          });
                          const addMemberForms: FormType[] =
                            allAddMemberForms.length > 0
                              ? [...allAddMemberForms, ...uploadedForms]
                              : uploadedForms;
                          setVisibleMemberFormIds((prevVisibleIds) => {
                            if (prevVisibleIds.length >= MAX_UPLOAD_LIMIT) {
                              return prevVisibleIds;
                            }
                            const availableSlots =
                              MAX_UPLOAD_LIMIT - prevVisibleIds.length;
                            const usersToDisplay = uploadedForms
                              .map((form) => form.id)
                              .filter((id) => !prevVisibleIds.includes(id))
                              .slice(0, availableSlots);

                            return [...prevVisibleIds, ...usersToDisplay];
                          });
                          setFieldValue(
                            userDrawerFormKey.ADD_MEMBER_FORMS,
                            addMemberForms
                          );
                          if (postFormData?.addMemberForms) {
                            onPostDataChange({
                              addMemberForms
                            });
                          } else {
                            onPostDataChange({
                              addMemberForms
                            });
                          }
                          setCheckValidationss(addMemberForms.length);
                        })
                        .catch(() => {
                          showMessage({
                            status: 'error',
                            message: 'Something went wrong'
                          });
                        })
                        .finally(() => {
                          setIsUploading(false);
                        });
                    }}
                    showUploadList={false}
                  >
                    <span ref={bulkUploadTriggerRef} style={{display: 'none'}}>
                      Trigger Bulk Upload
                    </span>
                  </Upload>
                  <Button
                    icon={<FileAddOutlined />}
                    type="primary"
                    loading={isUploading}
                    disabled={isVisibleLimitReached}
                    onClick={() => {
                      setIsBulkUploadModalOpen(true);
                    }}
                  >
                    {isUploading ? 'Uploading....' : 'Bulk Upload'}
                  </Button>
                  <Modal
                    title="Bulk Upload"
                    open={isBulkUploadModalOpen}
                    onOk={() => {
                      setIsBulkUploadModalOpen(false);
                      setShouldOpenBulkUploadPicker(true);
                    }}
                    onCancel={() => {
                      setIsBulkUploadModalOpen(false);
                    }}
                    okText="Continue"
                    cancelText="Cancel"
                    centered
                  >
                    {`It will accept only ${MAX_UPLOAD_LIMIT} users at a time`}
                  </Modal>
                  {shouldShowVisibleLimitInfo && (
                    <span style={{fontSize: '12px', color: '#777986'}}>
                      Showing first {MAX_UPLOAD_LIMIT} users in list
                    </span>
                  )}
                  <Button
                    icon={
                      <FileDownloadIcon
                        style={{
                          height: '25px',
                          width: '25px',
                          color: '#777986'
                        }}
                      />
                    }
                    type="primary"
                    style={{
                      border: '1px solid #777986',
                      background: 'white',
                      color: '#777986',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    href={SampleExcel.add_userManagement}
                    download
                  >
                    Sample .XLSX file
                  </Button>
                </div>
              </Col>

              <Col className="gutter-row" style={{padding: '0px !important'}}>
                <Form.Item
                  name="choose admin"
                  className="formNoShow"
                  label={
                    visibleAddMemberForms.length > 0 ? (
                      <span
                        style={{
                          fontSize: '16px',
                          fontWeight: 600,
                          marginBlock: '10px'
                        }}
                      >
                        Team Member Details
                      </span>
                    ) : (
                      ''
                    )
                  }
                  rules={[
                    {
                      required: true,
                      validator: async () => {
                        if (
                          postFormData.addMemberForms &&
                          postFormData.addMemberForms.length > 0
                        ) {
                          await Promise.resolve();

                          return;
                        }

                        return await Promise.reject(
                          new Error('Please Add at least one user.')
                        );
                      }
                    }
                  ]}
                ></Form.Item>
              </Col>
              <div>
                {visibleAddMemberForms.map((form: FormType, index: number) => {
                  const formIndex = allAddMemberForms.findIndex(
                    (memberForm) => memberForm.id === form.id
                  );

                  return (
                    <div key={form.id}>
                      <div style={{display: 'flex', gap: '16px'}}>
                        <Col className="gutter-row" style={{flex: 1}}>
                          <Form.Item
                            name={[
                              userDrawerFormKey.ADD_MEMBER_FORMS,
                              formIndex,
                              userDrawerFormKey.FIRST_NAME
                            ]}
                            label={userDrawerFormLabel.FIRST_NAME}
                            labelCol={{span: 10}}
                            rules={[
                              {
                                required: true,
                                message: CommonErrors.mandatory('First Name')
                              },
                              {
                                max: 100,
                                message:
                                  'First Name Should not be more than 100 Characters'
                              },
                              {
                                min: 2,
                                message:
                                  'First Name Should be more than 1 Characters'
                              },
                              {
                                pattern: RegEx.names,
                                message:
                                  'No special characters , Empty spaces or Numbers are Allowed'
                              }
                            ]}
                          >
                            <Input
                              style={{height: '40px'}}
                              placeholder="First Name"
                              value={form.firstName}
                              onInput={(e) => {
                                const target = e.target as HTMLInputElement;
                                target.value = FirstCap(target.value);
                              }}
                              onChange={(e) => {
                                handleInputChange(
                                  form.id,
                                  'firstName',
                                  e.target.value
                                );
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col className="gutter-row" style={{flex: 1}}>
                          <Form.Item
                            name={[
                              userDrawerFormKey.ADD_MEMBER_FORMS,
                              formIndex,
                              userDrawerFormKey.LAST_NAME
                            ]}
                            label={userDrawerFormLabel.LAST_NAME}
                            labelCol={{span: 10}}
                            rules={[
                              {
                                required: true,
                                message: CommonErrors.mandatory('Last Name')
                              },
                              {
                                max: 100,
                                message:
                                  'Last Name Should not be more than 100 Characters'
                              },
                              {
                                min: 2,
                                message:
                                  'Last Name Should be more than 1 Characters'
                              },
                              {
                                pattern: RegEx.names,
                                message:
                                  'No special characters , Empty spaces or Numbers are Allowed'
                              }
                            ]}
                          >
                            <Input
                              style={{height: '40px'}}
                              placeholder="Last Name"
                              value={form.lastName}
                              onInput={(e) => {
                                const target = e.target as HTMLInputElement;
                                target.value = FirstCap(target.value);
                              }}
                              onChange={(e) => {
                                handleInputChange(
                                  form.id,
                                  'lastName',
                                  e.target.value
                                );
                              }}
                            />
                          </Form.Item>
                        </Col>
                      </div>
                      <Col className="gutter-row">
                        <Form.Item
                          name={[
                            userDrawerFormKey.ADD_MEMBER_FORMS,
                            formIndex,
                            userDrawerFormKey.EMAIL
                          ]}
                          label={userDrawerFormLabel.EMAIL}
                          labelCol={{span: 24}}
                          hasFeedback
                          validateTrigger={['onChange', 'onBlur']}
                          validateFirst
                          rules={[
                            {
                              required: true,
                              message: CommonErrors.mandatory(
                                userDrawerFormLabel.EMAIL
                              )
                            },
                            {
                              min: 5,
                              message: `${userDrawerFormLabel.EMAIL} Should be more than 4 Characters`
                            },
                            {
                              max: 320,
                              message: `${userDrawerFormLabel.EMAIL} Should not be more than 320 Characters`
                            },
                            {
                              pattern: RegEx.email,
                              message: CommonErrors.validField(
                                userDrawerFormLabel.EMAIL
                              )
                            },
                            {
                              async validator(_, value) {
                                if (value) {
                                  const emailValue = normalizeEmail(value);

                                  if (
                                    findDuplicates(emailValue, 'emailAddress')
                                  ) {
                                    return await Promise.reject(
                                      new Error(
                                        CommonErrors.duplicatesFound(
                                          userDrawerFormLabel.EMAIL
                                        )
                                      )
                                    );
                                  }

                                  await isUserDuplicate({
                                    email: emailValue
                                  }).then(async (isDuplicate) => {
                                    isDuplicate?.status
                                      ? isDuplicate?.status === 'error'
                                        ? await Promise.reject(
                                            new Error(
                                              CommonErrors.alreadyExistsFound(
                                                userDrawerFormLabel.EMAIL
                                              )
                                            )
                                          )
                                        : await Promise.resolve()
                                      : await Promise.reject(
                                          new Error(
                                            'Something went wrong try again later'
                                          )
                                        );
                                  });
                                }
                              }
                            }
                          ]}
                        >
                          <Input
                            style={{height: '40px'}}
                            placeholder="Email Address"
                            value={form.emailAddress}
                            onChange={(e) => {
                              handleInputChange(
                                form.id,
                                'emailAddress',
                                e.target.value
                              );
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col className="gutter-row">
                        <Form.Item
                          name={[
                            userDrawerFormKey.ADD_MEMBER_FORMS,
                            formIndex,
                            userDrawerFormKey.MOBILE
                          ]}
                          label={userDrawerFormLabel.MOBILE}
                          labelCol={{span: 24}}
                          validateTrigger={['onChange', 'onBlur']}
                          validateFirst
                          hasFeedback
                          rules={[
                            {
                              required: true,
                              message: CommonErrors.mandatory(
                                userDrawerFormLabel.MOBILE
                              )
                            },
                            {
                              pattern: RegEx.mobile,
                              message: CommonErrors.validField(
                                userDrawerFormLabel.MOBILE
                              )
                            },
                            {
                              async validator(_, value) {
                                if (value) {
                                  const mobileValue = normalizeMobile(value);
                                  if (
                                    findDuplicates(mobileValue, 'phoneNumber')
                                  ) {
                                    return await Promise.reject(
                                      new Error(
                                        CommonErrors.duplicatesFound(
                                          userDrawerFormLabel.MOBILE
                                        )
                                      )
                                    );
                                  }

                                  await isUserDuplicate({mobile: value}).then(
                                    async (isDuplicate) => {
                                      isDuplicate?.status
                                        ? isDuplicate?.status === 'error'
                                          ? await Promise.reject(
                                              new Error(
                                                CommonErrors.alreadyExistsFound(
                                                  userDrawerFormLabel.MOBILE
                                                )
                                              )
                                            )
                                          : await Promise.resolve()
                                        : await Promise.reject(
                                            new Error(
                                              'Something went wrong try again later'
                                            )
                                          );
                                    }
                                  );
                                }
                              }
                            }
                          ]}
                        >
                          <PhoneNumberInput
                            name={`${userDrawerFormLabel.MOBILE} ${formIndex}`}
                            onChange={(e: any) => {
                              handleInputChange(form.id, 'phoneNumber', e);
                              // setFieldValue('')
                            }}
                          />

                          {/* <Input
                            style={{height: '40px'}}
                            placeholder="Mobile Number"
                            value={form.phoneNumber}
                            onChange={(e) => {
                              handleInputChange(
                                form.id,
                                'phoneNumber',
                                e.target.value
                              );
                            }}
                          /> */}
                        </Form.Item>
                      </Col>
                      <Flex
                        align="center"
                        // justify="space-between"
                        gap={'10px'}
                        style={{marginBottom: '20px'}}
                      >
                        {visibleAddMemberForms.length > 1 && (
                          <div style={{textAlign: 'start'}}>
                            <Button
                              icon={<MinusOutlined />}
                              style={{background: '#DA1E28', color: 'white'}}
                              onClick={() => {
                                handleRemoveForm(form.id);
                              }}
                            >
                              Remove
                            </Button>
                          </div>
                        )}
                        {visibleAddMemberForms.length > 0 &&
                          index === visibleAddMemberForms.length - 1 && (
                            <div style={{textAlign: 'start'}}>
                              {hasMaxLimitReached(
                                countModule.externalStakeholders,
                                postFormData?.addMemberForms?.length ?? 0
                              ) ? (
                                <UpgradeButton title="Add Member" />
                              ) : (
                                <Button
                                  icon={<PlusOutlined />}
                                  type="primary"
                                  onClick={handleAddForm}
                                  disabled={isVisibleLimitReached}
                                >
                                  Add Member
                                </Button>
                              )}
                            </div>
                          )}
                      </Flex>
                      <Divider />
                    </div>
                  );
                })}
              </div>
            </>
          )}

        {postFormData.selectedStackHolder === 'Internal' && (
          <Col>
            {/* <div style={{textAlign: 'right', marginBottom: '10px'}}>
              <Checkbox checked={selectAll} onChange={handleSelectAllChange}>
                Select All
              </Checkbox>
            </div> */}
            <Form.Item
              name="Admin Select"
              className="formNoShow"
              labelCol={{span: 24}}
              label="Select Admin/Stakeholder"
              rules={[
                {
                  required: true,
                  validator: async () => {
                    if (postFormData?.users && postFormData.users.length > 0) {
                      await Promise.resolve();

                      return;
                    }

                    return await Promise.reject(
                      new Error('Please select at least one user.')
                    );
                  }
                }
              ]}
            />
            {isLoading ? (
              <Loader />
            ) : (
              <div
                className="e3"
                style={{
                  border: '1px solid #D2D4DA',
                  borderRadius: '12px',
                  overflow: 'hidden'
                }}
              >
                <Table
                  rowKey="key"
                  rowSelection={multiRowSelection}
                  dataSource={editUsers}
                  columns={columns}
                  pagination={false}
                  className="custom-table"
                  showHeader={false}
                  loading={isLoadingSelectTable}
                  scroll={{y: 500}}
                  {...({
                    onScroll: (e: any) => {
                      const maxScroll =
                        e.target.scrollHeight - e.target.clientHeight;
                      const currentScroll = e.target.scrollTop;

                      const {page, pageSize, total} = pagination;

                      if (currentScroll === maxScroll) {
                        if (page * pageSize < total) {
                          setShouldCallAPI(true);
                          setPagination((prev) => {
                            const {page} = prev;

                            return {...prev, page: page + 1};
                          });
                        } else {
                          showMessage({
                            status: 'info',
                            message: 'End Of List'
                          });
                        }
                      }
                    }
                  } as any)}
                />
              </div>
            )}
          </Col>
        )}

        <Form.Item
          initialValue={getLabelsFromSelectedPermissions(
            allPermissions,
            postFormData.permissions
          )}
          name="selectedPermissions"
        ></Form.Item>
      </>
    );

  return null;
};

export default AddUserDrawerForm;
